import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=2e7c8062&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7c8062')) {
      api.createRecord('2e7c8062', component.options)
    } else {
      api.reload('2e7c8062', component.options)
    }
    module.hot.accept("./ForgetPassword.vue?vue&type=template&id=2e7c8062&", function () {
      api.rerender('2e7c8062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ForgetPassword.vue"
export default component.exports